export default color => {
  return {
    fontColor: color,
    glyphFillColor: color,
    barcodeColor: color,
    shapeStrokeColor: color,
    shapeFillColor: color,
  };
};
